<template>
    <div id="userList">
        <div class="search">
            <div class="block_box">
                <div class="p_select search_day_list" >
                    <div @mouseover="onMouseOver('start')" @mouseleave="onMouseleave('start')">
                        <el-date-picker
                                v-model="beginDate"
                                type="date"
                                value-format="yyyy-MM-dd"
                                :picker-options="pickerDayOptions"
                                prefix-icon="''"
                                class="datepicker"
                                @change="getDailyTestAndDeal"
                                placeholder="选择开始日期">
                        </el-date-picker>
                        <i class="el-icon-date" ref="iconDateStart"></i>
                    </div>
                </div>
                <div class="p_select search_day_list" >
                    <div @mouseover="onMouseOver('end')" @mouseleave="onMouseleave('end')">
                        <el-date-picker
                                v-model="endDate"
                                type="date"
                                value-format="yyyy-MM-dd"
                                :picker-options="pickerDayOptions"
                                prefix-icon="''"
                                class="datepicker"
                                @change="getDailyTestAndDeal"
                                placeholder="选择结束日期">
                        </el-date-picker>
                        <i class="el-icon-date" ref="iconDateEnd"></i>
                    </div>
                </div>
                <div class="p_select">
                    <el-select v-model="positionType" clearable placeholder="请选择部位类型" @change="getDailyTestAndDeal">
                        <el-option label="备件" value="1"></el-option>
                        <el-option label="附件" value="2"></el-option>
                    </el-select>
                </div>
                <div class="p_select">
                    <el-button class="search_btn" @click="getDailyTestAndDeal" >查询</el-button>
                    <el-button class="add_btn" @click="exportTable('#dailyTestAndDeal')" >导出</el-button>
                </div>
                <div class="p_select" style="float: right">
                    <a class="customize_btn" @click="setCustomizeRow"><i class="el-icon-edit"></i>自定义列</a>
                </div>
            </div>
        </div>

        <div class="table">
            <el-table id="dailyTestAndDeal"
                      :data="dailyTestAndDealData"
                      style="width:100%"
                      :row-key="getRowKey"
                      :tree-props="{children: 'children'}"
                      ref="table"
                      :expand-row-keys="expandRowKeys"
                      sortable="true"
                      :height=winHeight
                      show-summary
                      :summary-method="getDailyTestAndDealDataSummaries"
                      :cell-style="cellStyle"
                      :header-cell-style="tableHeaderColor" >

                <el-table-column prop="checkDay" label="日期" align="left"></el-table-column>
                <el-table-column prop="carCount" label="进站台次" align="left"></el-table-column>
                <el-table-column prop="testNum" label="检测台数" align="left" sortable></el-table-column>
                <el-table-column prop="carCountRate" label="检测覆盖率" align="left" sortable :sort-method="(a,b)=>{return a.carCountRate - b.carCountRate}">
                    <template slot-scope="scope">
                        <span>{{scope.row.carCountRate >0? (scope.row.carCountRate+"%") : '-'}}</span>
                    </template>
                </el-table-column>
                <el-table-column :prop="col.prop" :label="col.label" v-for="(col,index) in activeFields" :key="index" sortable :sort-method="(a, b) => {return a[col.prop] - b[col.prop]}"  >
                    <template slot-scope="scope">
                        <span v-if="col.prop.substring(col.prop.length - 4) === 'Rate'">{{scope.row[col.prop] >0? (scope.row[col.prop]+"%") : '-'}}</span>
                        <span v-else-if="col.prop.substring(col.prop.length - 3) === 'Avg'">{{scope.row[col.prop] >0? (scope.row[col.prop]) : '-'}}</span>
                        <span v-else>{{scope.row[col.prop]}}</span>
                    </template>
                </el-table-column>
            </el-table>

        </div>


        <el-dialog
                title="自定义表格列"
                :visible.sync="customizeRow"
                center
                width="600px">
            <el-tabs v-model="activeName">
                <el-tab-pane label="字段选择" name="fieldsChosen">
                    <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全部</el-checkbox>
                    <div style="margin:15px 0;"></div>
                    <el-checkbox-group  v-model="checkedColumns" @change="handleCheckedList">
                        <div>
                            <el-checkbox style="width:40%;line-height: 30px;" v-for="item in columns" :label="item" :key="item">{{item}}</el-checkbox>
                        </div>
                    </el-checkbox-group>

                </el-tab-pane>
                <el-tab-pane label="字段顺序" name="fieldSorted">
                    <vuedraggable v-model="fieldList">
                        <transition-group>
                            <div v-for="field in fieldList"
                                 :key="field"
                                 class="field_item">
                                {{field}}
                            </div>
                        </transition-group>
                    </vuedraggable>

                </el-tab-pane>
            </el-tabs>
            <span slot="footer" class="dialog-footer">
                <el-button class="buttonLeft" type="primary" plain @click="recoverChecked">恢复默认</el-button>
                <el-button @click="customizeRow = false" class="buttonRight">取 消</el-button>
                <el-button type="primary" @click="submit" class="buttonRight" >确 定</el-button>
            </span>
        </el-dialog>




        <el-button class="slider_button" type="text" @click="openQuestionDialog" v-if="enableAiCheck" >
            <img src="../../assets/img/ai/ziti.svg" > <img src="../../assets/img/ai/suohui.svg" style="margin-top: 20px"/>
        </el-button>

        <el-drawer
                :with-header="false"
                :visible.sync="dialog1"
                direction="rtl"
                class="slider_drawer"
                ref="drawer"
                size="568px"
        >
            <div class="ai_box">
                <div class="left-div">
                    <img src="../../assets/img/ai/tubiao.svg" width="55px" height="65px">
                </div>
                <div class="right-div">
                    <!--<img src="../../assets/img/ai/wenzi.svg"  alt="ai数据看板分析" class="right-div-image">-->
                    <span style="font-size: 24px;font-weight: 700;color: #0656ac;">AI商业智能分析</span>
                    <img src="../../assets/img/ai/logopicture.svg" alt="logo" class="right-div-image">
                </div>
            </div>
            <div class="chat-window">
                <template>
                    <div class="question-content-wrapper">
                        <!-- 表格 -->
                        <div class="xiaoyi">
                            <!--<img src="../../assets/img/ai/movie(6).svg" alt="图标" class="tubiaoimg">-->
                            <img src="../../assets/img/ai/我是小易.svg" alt="我是小易">
                        </div>
                        <div class="gradient-background">
                            <div class="question-suggestions">
                                <h3>
                                    <div >
                                        <img src="../../assets/img/ai/问号.svg" alt="？" >
                                        <img src="../../assets/img/ai/猜您想问.svg" alt="猜您想问" >
                                    </div>
                                    <div class="change_question_statue" @click="hideQuestion" v-show="isShowQuestion">
                                        <span>收起</span>
                                        <img src="../../assets/img/ai/close_open.png">
                                    </div>
                                    <div class="change_question_statue" @click="showQuestion" v-show="!isShowQuestion">
                                        <span>展开</span>
                                        <img src="../../assets/img/ai/close_open.png" style="transform: rotate(180deg);">
                                    </div>
                                </h3>
                                <ul v-show="isShowQuestion">
                                    <li v-for="question in newFiveQuestions" :key="question.id" @click="handleClick(question.question)">
                                        <div class="five_questions_item">
                                            <div class="msg_img"><img src="../../assets/img/ai/msg.png" alt=""></div>
                                            <div class="list-item-content">
                                                <span >{{ question.question }}</span>
                                                <img src="../../assets/img/ai/箭头.svg" alt="箭头" class="list-item-image">
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </template>

                <div class="messages" ref="messagesContainer">
                    <!-- 遍历 messages 数组并显示每条消息 -->
                    <div v-for="(message, index) in messages" :key="index" class="message" :class="{ 'my-message': message.mine }">
                        <!--                              <div class="message-content">{{ message.text }}</div>-->
                        <div v-html="message.text" class="message-content"></div>
                        <div class="op_box" v-if="!message.mine">
                            <div class="agree op_item" v-if="!message.agree" @click="message.agree = true;message.against = false"><img src="../../assets/img/ai/against.png" /></div>
                            <div class="agree op_item" v-if="message.agree" @click="message.agree = false"><img src="../../assets/img/ai/agree.png" /></div>
                            <div class="against op_item" v-if="!message.against" @click="message.against = true;message.agree = false"><img src="../../assets/img/ai/against.png" /></div>
                            <div class="against op_item" v-if="message.against" @click="message.against = false"><img src="../../assets/img/ai/agree.png" /></div>
                            <div class="copy op_item" @click="copyMessage(message.text)">
                                <i class="el-icon-document-copy"></i>
                                <span>复制</span>
                            </div>
                        </div>
                        <!--                              <div class="message-meta">{{ message.timestamp }}</div>-->
                    </div>
                </div>

                <!-- ：文本输入框和按钮 -->
                <div style="font-size: 16px;color: #787878;" v-show="showLoading"><span>小易正在思考，请稍后......</span></div>
                <div class="input-container">
                    <input type="text" placeholder="请在此输入问题" v-model="questionText" class="input-text">
                    <div class="icons">
                        <img src="../../assets/img/ai/voicebutton.svg" alt="语音输入" class="icon">
                    </div>
                    <div class="icons" @click="showHistoryList">
                        <img src="../../assets/img/ai/functionbutton.svg" alt="更多" class="icon">
                    </div>
                    <el-button type="primary" size="small" :disabled="isLoading" @click="sendaiQuestion">发送</el-button>
                    <!--<button class="send-button" @click="sendaiQuestion"><img src="../../assets/img/ai/sendbutton.svg"></button>-->
                </div>
            </div>


            <el-drawer
                    :with-header="false"
                    :append-to-body="true"
                    :visible.sync="innerDrawer"
                    size="440px"
            >
                <div class="ai_box" style="margin-top: 10px">
                    <div class="left-div">
                        <img src="../../assets/img/ai/logopicture.svg" width="167px" height="70px">
                    </div>
                    <div class="right-div">
                        <p class="history_title">HI 这里是小易</p>
                        <p class="history_title" style="font-weight: bold">您的智能AI销售助手</p>
                    </div>
                </div>
                <div class="history_box">
                    <div class="detail_title_box">
                        <div class="title_img">
                            <img src="../../assets/img/ai/time.png">
                        </div>
                        <div class="title_label"><span>会话历史</span></div>
                    </div>
                    <div class="history_list">
                        <div v-for="(item, index) in chatHistory" :key="index">
                            <div class="history_item" @click="getHistoryDetail(item)">
                                <div class="item_img"><img src="../../assets/img/ai/msg.png" alt=""></div>
                                <div class="item_label">{{item.name}}</div>
                            </div>
                        </div>
                        <div class="history_item" @click="openNewChat">
                            <div class="item_img"><img src="../../assets/img/ai/msg.png" alt=""></div>
                            <div class="item_label">新话题</div>
                        </div>
                    </div>
                </div>
            </el-drawer>


        </el-drawer>

        <el-dialog
                title="会话详情"
                :visible.sync="showHistoryDetail"
                width="80%"
        >
            <div class="detail_item"><span>问：{{detailQuestion}}</span></div>
            <!--<div class="detail_item">答：<br />
                <div v-html="detailAnswer">
                    <pre> {{ detailAnswer }}</pre>
                </div>
            </div>-->
            <div class="detail_item">
                <pre><code>答：<br /> {{ detailAnswer }}</code></pre>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="showHistoryDetail = false">关 闭</el-button>
            </span>
        </el-dialog>

    </div>
</template>

<script>
  import vuedraggable from 'vuedraggable';
  const columnOptions=['轮胎检测台数','轮胎检测台数占比','蓄电池检测台数','蓄电池检测台数占比','检出台数', '台数检出率','成交台数','检出台数成交率','检测项目数','单台项目检测均值',
    '检出项目数','项目检出率','单台项目检出均值','成交项目数', '检出项目成交率','项目成交率','前置成交项目数',
    '增项成交率', '单车平均成交项目数', '报告合格率', '系统使用率',
    '销售登记率','服务顾问点击率','客户点击率', ];
  import net from "../../assets/js/public";
  import XLSX from "xlsx";
  import FileSaver from "file-saver";
  import Vue from 'vue'
  import VueClipboard from 'vue-clipboard2'
  import waterfall from 'vue-waterfall2'
  import html2canvas from 'html2canvas'
  Vue.use(VueClipboard)
  Vue.use(waterfall)
  export default {
    name: "detectionSummary",
    components: {
      vuedraggable
    },
    data(){
      return {
        orgId: "",
        orgArr: [], //所有集团下所有站点
        dailyTestAndDealData:[],
        winHeight:'200',
        beginDate:'',
        endDate:'',
        positionType:'',
        pickerDayOptions: { // 按天 当天、当月可选
          disabledDate(time) {
            return time.getTime() > Date.now() + 1 * 24 * 60 * 60 * 1000;
          }
        },
        dossierPositionImgNumSum : 0 ,// 上传照片数 合计
        itemFaultDealNumSum : 0 , //异常项目登记数 合计
        carOwnerRequestPersonSum : 0 , //疑似客户数 合计
        systemUseRateAvg:0,
        abnormalFeedbackItemNumSum : 0,  //紧急项目登记数 合计
        criticalItemNumSum : 0,  //紧急项目数 合计
        testNumSum : 0 ,
        faultNumSum : 0 ,
        dealNumSum : 0 ,
        itemCheckNumSum : 0 ,
        itemFaultNumSum : 0 ,
        itemDealNumSum : 0 ,
        itemDealRateAvg : 0 ,

        tireTestNumSum : 0 ,
        batteryTestNumSum : 0 ,

        customizeRow: false, //自定义列
        expandRowKeys: [],
        activeName:'fieldsChosen',
        // 列信息
        checkedColumns:['轮胎检测台数','轮胎检测台数占比','蓄电池检测台数','蓄电池检测台数占比', '检出台数', '台数检出率','成交台数','检出台数成交率','检测项目数','单台项目检测均值',
          '检出项目数','项目检出率','单台项目检出均值','成交项目数', '检出项目成交率','项目成交率','前置成交项目数',
          '增项成交率', '单车平均成交项目数', '报告合格率', '系统使用率',
          '销售登记率','服务顾问点击率','客户点击率'],
        checkAll:false,
        columns:columnOptions,
        isIndeterminate:true,
        fieldsTemp:[],//存放按指定顺序排列的fields数组
        fields:[
          {label:"轮胎检测台数", prop:"tireTestNum", visible: true},
          {label:"轮胎检测台数占比", prop:"tireTestRate", visible: true },
          {label:"蓄电池检测台数", prop:"batteryTestNum", visible: true },
          {label:"蓄电池检测台数占比", prop:"batteryTestRate", visible: true },

          {label:"检出台数", prop:"faultNum", visible: true},
          {label:"台数检出率", prop:"faultNumRate", visible: true },
          {label:"成交台数", prop:"dealNum", visible: true },
          {label:"检出台数成交率", prop:"dealNumRate", visible: true },
          {label:"检测项目数", prop:"itemCheckNum", visible: true },
          {label:"单台项目检测均值", prop:"itemCheckNumAvg" , visible: true },
          {label:"检出项目数", prop:"itemFaultNum", visible: true },
          {label:"项目检出率", prop:"itemFaultRate", visible: true },
          {label:"单台项目检出均值", prop:"itemTestOutNumAvg", visible: true },
          {label:"成交项目数", prop:"itemDealNum", visible: true },
          {label:"检出项目成交率", prop:"itemFaultNumRate", visible: true },
          {label:"项目成交率", prop:"itemDealRate", visible: true },
          {label:"前置成交项目数", prop:"receptionSalesNum", visible: true },

          {label:"增项成交率", prop:"shopSalesNumRate", visible: true },

          {label:"单车平均成交项目数", prop:"carDealItemAvg", visible: true },
          {label:"报告合格率", prop:"reportQualifiedRate", visible: true },
          {label:"系统使用率", prop:"systemUseRate", visible: true },
          {label:"销售登记率", prop:"saleRegistrationRate", visible: true },
          {label:"服务顾问点击率", prop:"percentage", visible: true },
          {label:"客户点击率", prop:"customClickRate", visible: true },
        ],
        fieldList:columnOptions,
        totalPercentage: '', //合计行的服务顾问点击率



        //以下
        enableAiCheck: true,
        screenshot: null, // 存储截图的URL
        screenshot_id:'',
        questionText:'',
        messages: [],
        dialog1: false,
        table: false,
        loading: false,
        showlogo:true,
        isSendActive: false,
        // 问题信息数组，从后端获取
        questions: [],

        conversation_id:'',
        showLoading: false,
        chatHistory:[],

        innerDrawer: false,
        showHistoryDetail: false,
        detailQuestion: '',
        detailAnswer: '',
        isLoading: false,
        isShowQuestion: true, //猜你想问 是否显示
        upload_file_id: '',

      }
    },
    created() {

      let signInfo = JSON.parse(sessionStorage.getItem("signInfo"));
      if(signInfo.orgId > 0){
        this.orgId = signInfo.orgId
      }
      let obj = new Date();
      let month = obj.getMonth() + 1;
      if (month < 10) month = "0" + month;
      let day = obj.getDate();
      if (day < 10) day = "0" + day;


      // 明天
      let after = new Date(new Date().getTime() + 24 * 60 * 60 * 1000)//后一天
      let afterMonth = after.getMonth() + 1;
      if (afterMonth < 10) afterMonth = "0" + afterMonth;
      let afterDay = after.getDate()
      if (afterDay < 10) afterDay = "0" + afterDay;

      let beginDate = obj.getFullYear() + "-" + month + "-01"; //本月第一天
      let endDate = after.getFullYear() + "-" + afterMonth + "-" + afterDay; //明天

      this.beginDate = beginDate
      this.endDate = endDate;


      this.getDailyTestAndDeal()


      this.fetchQuestions();
    },
    methods:{


      fetchQuestions() {
        // 从后端获取问题信息
        net.request('admin/manage/ai_chat/opening-statement?subRouteName=/detectionSummary',"get").then(response => {
          if(response.code === 0){
            const data = response.data;
            this.questions = data.questions
          }else {
            net.message(this, response.msg)
          }
        }).catch(error => {
          console.error('Error fetching questions:', error);
        });
      },
      //收起
      hideQuestion(){
        this.isShowQuestion = false
      },
      //展开
      showQuestion(){
        this.isShowQuestion = true
      },
      handleClick(question) {
        // 处理按钮点击事件
        this.questionText=question;
        this.sendaiQuestion();
      },
      openQuestionDialog() {
        this.dialog1 = true;
        this.captureFullPageScreenshot(); ////截屏方法
      },
      // 对话
      sendaiQuestion() {
        if(this.isLoading){
          net.message(this, '已存在正在询问的问题，请稍后再试', 'warning')
          return;
        }
        if(this.questionText.trim() === '') return;
        this.showLoading = true
        this.showlogo=false;
        this.isLoading = true
        // 准备要发送的数据
        const formData = {
          subRouteName: '/detectionSummary',
          conversation_id: this.conversation_id || '',
          upload_file_id: this.upload_file_id,
          question: this.questionText,
          message : {
            年份: this.checkYear,
            // 开始日期
            开始日期: this.beginDate,
            // 结束日期
            结束日期: this.endDate,

            综合数据:this.dailyTestAndDealData.map(item => ({
              // 检测日期:item.checkDay,
              // 进站台次:item.carCount,
              // 检测台次:item.testNum,
              // 检出台次:item.faultNum,
              // 成交台数:item.dealNum,
              // 检测项目数:item.itemCheckNum,
              // 检出项目数:item.itemFaultNum,
              //
              // 成交项目数:item.itemDealNum,
              // 前置成交项目数:item.receptionSalesNum,



              进站台次: item.carCount,
              检测台次: item.testNum,
              检测覆盖率: item.carCountRate + '%',
              项目成交率: item.itemDealRate + '%',
              前置成交项目数: item.receptionSalesNumreceptionSalesNum,
              增项成交率: item.shopSalesNumRate + '%',
              销售登记率: item.saleRegistrationRate + '%',
              服务顾问点击率: item.percentage,
              客户点击率: item.customClickRate + '%',
              单台项目检出均值: item.itemTestOutNumAvg,
              // 平均单车检出项目数: ,




            }))
          }
        };

        // 发送POST请求到后端API
        console.log(this.questionText)
        this.messages.push({
          text: this.questionText,
          mine: true,
          timestamp: new Date().toLocaleString()
        });
        this.questionText = ''; // 清空文本框
        this.scrollToBottom();
        console.log(formData.questionText)

        net.request('admin/manage/ai_chat/communicateBI',"post",null, formData)
          .then(response => {
            // 处理响应
            console.log('问题已发送', response);
            console.log(response.data+"111");
            //将后端的回复添加到消息列表
            if(response.data==="{\"code\":\"invalid_param\",\"message\":\"Invalid upload file\",\"status\":400}"){
              this.messages.push({
                text: "ai信息有误，请重新提问",
                mine: false,
                timestamp: new Date().toLocaleString()

              });
            }else if (response.code === 0){
              let data = JSON.parse(response.data)
              console.log(data)

              this.messages.push({
                text: data.answer,
                mine: false,
                timestamp: new Date().toLocaleString(),
                agree: false,
                against: false,
              });
              this.conversation_id = data.conversation_id
            }else{
              net.message(this, response.msg, 'info')
            }
            //滚动到最新消息
            this.scrollToBottom();
            this.showLoading = false
            this.isLoading = false



          })
          .catch(error => {
            // 处理错误
            console.error('请求失败:', error);
            this.messages.push({
              text: "请求失败，无法获取AI的回答。",
              mine: false,
              timestamp: new Date().toLocaleString()
            });
            this.showLoading = false
            this.isLoading = false
          });
      },

      scrollToBottom() {
        this.$nextTick(() => {
          const container = this.$refs.messagesContainer;
          container.scrollTop = container.scrollHeight;
        });
      },


      // 历史列表
      showHistoryList(){
        const params = {
          subRouteName: '/detectionSummary',
          last_id: this.conversation_id || null,
          limit: 12,
        }
        net.request("admin/manage/ai_chat/queryConversation", "post", params).then(res => {
          if(res.code === 0){
            let data = res.data
            this.chatHistory = data
            this.innerDrawer = true
          }else {
            net.message(this, res.msg, "warning")
          }
        })
      },
      getHistoryDetail(item){
        console.log("eeeeee",item)
        const params = {
          subRouteName: '/detectionSummary',
          conversation_id: item.id,
          first_id: item.first_id || '',
          limit: 1
        }
        net.request("admin/manage/ai_chat/queryMessage", "post", params).then(res => {
          if(res.code === 0){
            let data = res.data
            this.showHistoryDetail = true
            this.detailQuestion = item.name
            this.detailAnswer = data[0].answer
          }else {
            net.message(this, res.msg, "warning")
          }
        })
      },
      // 新话题
      openNewChat(){
        this.conversation_id = ''
        this.innerDrawer = false
      },

      //复制
      copyMessage(text){
        // let authCode = row.authCode
        let oInput = document.createElement('input');
        oInput.value = text;
        document.body.appendChild(oInput);
        oInput.select(); // 选择对象;
        document.execCommand("Copy"); // 执行浏览器复制命令
        this.$message({
          message: '复制成功',
          type: 'success'
        });
        oInput.remove()
      },

      //截屏方法
      captureFullPageScreenshot() {
        const body = document.body;
        const width = body.scrollWidth;
        const height = body.scrollHeight;
        const options = {
          width: width,
          height: height,
          windowWidth: document.documentElement.scrollWidth,
          windowHeight: document.documentElement.scrollHeight,
          scrollX: window.scrollX,
          scrollY: window.scrollY
        };

        html2canvas(body).then(canvas => {
          const imageData = canvas.toDataURL('image/png');
          // console.log("截屏",imageData)
          this.uploadImage(imageData);
        }).catch(error => {
          console.error('截图失败', error);
        });
      },

      //上传图片
      uploadImage(imageData) {
        const formData = new FormData();
        const blob = this.dataURItoBlob(imageData);
        const filename = `screenshot-${Date.now()}.png`;
        const file = new File([blob], filename, { type: 'image/png' });
        formData.append('file', file);

        net.request('admin/manage/ai_chat/uploadImage', "post",null,formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
          .then(response => {
            if(response.code === 0){
              console.log('图片上传成功', response);
            }else {
              net.message(this, response.msg, 'warning')
            }
            this.upload_file_id = response.data;
          })
          .catch(error => {
            console.error('图片上传失败', error);
          });
      },
      dataURItoBlob(dataURI) {
        // Convert Base64/URLEncoded data component to raw binary data held in a string
        var byteString;
        if (dataURI.split(',')[0].indexOf('base64') >= 0)
          byteString = atob(dataURI.split(',')[1]);
        else
          byteString = decodeURIComponent(dataURI.split(',')[1]);

        // Separate out the mime component
        var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

        // Write the bytes of the string to a typed array
        var ia = new Uint8Array(byteString.length);
        for (var i = 0; i < byteString.length; i++) {
          ia[i] = byteString.charCodeAt(i);
        }

        return new Blob([ia], {type:mimeString});
      },







      onMouseOver(item) {
        if(item == 'start'){
          this.$refs.iconDateStart.style.display = 'none';
        }else {
          this.$refs.iconDateEnd.style.display = 'none';
        }
      },
      onMouseleave(item) {
        if(item == 'start'){
          this.$refs.iconDateStart.style.display = 'block';
        }else {
          this.$refs.iconDateEnd.style.display = 'block';
        }
      },

      // 检出&成交 合计
      getDailyTestAndDealDataSummaries(param){
        /*
        * sums[0] 合计    1 进站台次  2检测台次 3检测覆盖率 4检出台数 5台数检出率 6成交台数 7台数成交率
        *                 8检测项目数 9单台项目检测均值  10检出项目数 11项目检出率  12单台项目检出均值  13成交项目数 14项目成交率 15单车平均成交项目数
        * */
        const { columns, data } = param;
        const sums = [];
        columns.forEach((column, index) => {
          // console.log("propertypropertypropertyproperty",column.property)
          if (index === 0) {
            sums[index] = '合计';
            return;
          }
          if (index === 3) {// 检测覆盖率
            sums[index] = sums[1] >0 ? ((sums[2] / sums[1])*100).toFixed(1) + '%' : '-';
            return;
          }

          if (column.property === 'tireTestRate') {// 轮胎检测台数占比
            sums[index] = sums[2] >0 ? ((this.tireTestNumSum / sums[2])*100).toFixed(1) + '%' : '-';
            return;
          }
          if (column.property === 'batteryTestRate') {// 轮胎检测台数占比
            sums[index] = sums[2] >0 ? ((this.batteryTestNumSum / sums[2])*100).toFixed(1) + '%' : '-';
            return;
          }
          if (column.property === 'faultNumRate') {// 台数检出率
            sums[index] = this.testNumSum >0 ? ((this.faultNumSum / this.testNumSum)*100).toFixed(1) + '%' : '-';
            return;
          }
          if (column.property === 'dealNumRate') {// 台数成交率
            sums[index] = this.faultNumSum >0 ? ((this.dealNumSum / this.faultNumSum)*100).toFixed(1) + '%' : '-';
            return;
          }
          if (column.property === 'itemCheckNumAvg') {// 单台项目检测均值
            sums[index] = this.testNumSum >0 ? (this.itemCheckNumSum / this.testNumSum).toFixed(1) : '-';
            return;
          }
          if (column.property === 'itemFaultRate') {// 项目检出率
            sums[index] = this.itemCheckNumSum >0 ? ((this.itemFaultNumSum / this.itemCheckNumSum)*100).toFixed(1) + '%' : '-';
            return;
          }
          if (column.property === 'itemTestOutNumAvg') {// 单台项目检出均值
            sums[index] = this.faultNumSum >0 ? (this.itemFaultNumSum / this.faultNumSum).toFixed(1) : '-';
            return;
          }
          if (column.property === 'itemFaultNumRate') {// 检出项目成交率
            sums[index] = this.itemFaultNumSum >0 ? ((this.itemDealNumSum / this.itemFaultNumSum)*100).toFixed(1) + '%' : '-';
            return;
          }
          if (column.property === 'itemDealRate') {// 项目成交率
            sums[index] = this.itemDealRateAvg >0 ? this.itemDealRateAvg+ '%' : '-';
            return;
          }

          if (column.property === 'shopSalesNumRate') {// 增项成交率
            sums[index] = this.itemCheckNumSum >0 ? ((this.shopSalesNumSum / this.itemCheckNumSum)*100).toFixed(1) + '%' : '-';
            return;
          }

          if (column.property === 'carDealItemAvg') {// 单车平均成交项目数
            sums[index] = this.dealNumSum >0 ? (this.itemDealNumSum / this.dealNumSum).toFixed(1) : '-';
            return;
          }
          if (column.property === 'reportQualifiedRate') {// 报告合格率
            sums[index] = this.itemCheckNumSum >0 ? ((this.dossierPositionImgNumSum / this.itemFaultNumSum)*100).toFixed(1)+ '%' : '-';
            return;
          }
          if (column.property === 'systemUseRate') {// 系统使用率
            sums[index] = this.systemUseRateAvg >0 ? this.systemUseRateAvg+ '%' : '-';
            return;
          }
          if (column.property === 'percentage') {// 服务顾问点击率
            sums[index] = this.totalPercentage
            return;
          }
          if (column.property === 'saleRegistrationRate') {// 销售登记率
            sums[index] = this.criticalItemNumSum >0 ? ((this.abnormalFeedbackItemNumSum / this.criticalItemNumSum)*100).toFixed(1)+ '%' : '-';
            return;
          }
          // if (index === 19) {// 客户点击率
          if (column.property === 'customClickRate') {// 客户点击率
            sums[index] = this.testNumSum >0 ? ((this.carOwnerRequestPersonSum / this.testNumSum)*100).toFixed(1)+ '%' : '-';
            return;
          }
          const values = data.map(item => Number(item[column.property]));
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
            // sums[index] += ' 元';
          } else {
            sums[index] = '-';
          }
        });
        return sums;
      },
      // 表头样式
      tableHeaderColor({ row, column, rowIndex, columnIndex }) {
        return "background-color:#F3F7FB; color: #364556; text-align: left;font-size: 14px;height: 48px;font-weight: 500;font-family: 'PingFang SC';";
      },
      cellStyle({ row, column, rowIndex, columnIndex }) {
        if(row.columnIndex == 0){
          return 'color: #0D0E12;font-weight: 500;font-size: 14px;'
        }else{
          return 'color: #0D0E12;font-weight: 400;'
        }
      },

      // 检出&成交数据
      getDailyTestAndDeal() {
        this.dailyTestAndDealData = []
        if (this.beginDate === "" || this.beginDate === null || this.endDate === "" || this.endDate === null) {
          net.message(this, "请选择完整的查询条件", "warning");
          return;
        }
        const params = {
          beginDate: this.beginDate,
          endDate: this.endDate,
          positionType: this.positionType*1,
        }
        net.request("admin/manage/report/getDailyTestAndDeal", "post", null, params).then(res => {
          if (res.code == 0) {
            net.message(this, "查询成功", "success");
            this.$nextTick(() => {
              this.$refs['table'].doLayout();
            })
            let data = res.data.resultList
            let managerNum = res.data.managerNum


            let testNumSum = 0 //检测台次 合计
            let faultNumSum = 0 //检出台数 合计
            let dealNumSum = 0 //成交台次 合计
            let itemCheckNumSum = 0 //检测项目数 合计
            let itemFaultNumSum = 0 //检出项目数 合计
            let itemDealNumSum = 0 //成交项目数 合计

            let tireTestNumSum = 0 //轮胎检测台数 合计
            let batteryTestNumSum = 0 //蓄电池检测台数 合计


            let dossierPositionImgNumSum = 0 // 上传照片数 合计
            let itemFaultDealNumSum = 0  //异常项目登记数 合计
            let carOwnerRequestPersonSum = 0  //疑似客户数 合计
            let managerActionPersonSum = 0  //管理人员登录人数 合计
            let abnormalFeedbackItemNumSum = 0  //紧急项目登记数 合计
            let criticalItemNumSum = 0  //紧急项目数 合计
            let receptionSalesNumSum = 0 //前置成交项目数 合计
            let shopSalesNumSum = 0 //增项成交项目数 合计


            data.forEach(item => {


              item.carCountRate = item.carCount >0 ? ((item.testNum / item.carCount)*100).toFixed(1) : 0 // 检测覆盖率  检测台数/进站台次


              item.faultNumRate = item.testNum>0 ? ((item.faultNum / item.testNum)*100).toFixed(1) : 0 //台数检出率   检出 / 检测
              item.dealNumRate = item.faultNum>0 ? ((item.dealNum / item.faultNum)*100).toFixed(1) : 0 //检出台数成交率   成交 / 检出
              item.itemFaultRate = item.itemCheckNum>0 ? ((item.itemFaultNum / item.itemCheckNum)*100).toFixed(1) : 0 // 项目检出率   检出项目数 / 检测项目数
              item.itemFaultNumRate = item.itemFaultNum>0 ? ((item.itemDealNum / item.itemFaultNum)*100).toFixed(1) : 0 //检出项目成交率  成交项目数 / 检出项目数
              item.itemTestOutNumAvg = item.faultNum>0 ? (item.itemFaultNum / item.faultNum).toFixed(1) : '-' //单台项目检出均值  检出项目 / 检出台数

              item.carDealItemAvg = item.dealNum>0 ? (item.itemDealNum / item.dealNum).toFixed(1) : 0 //单车平均成交项目数

              item.itemCheckNumAvg = item.testNum>0 ? (item.itemCheckNum / item.testNum).toFixed(1) : 0 //单台项目检测均值   检测项目数 / 检测台次

              item.reportQualifiedRate = item.itemFaultNum>0 ? ((item.dossierPositionImgNum / item.itemFaultNum)*100).toFixed(1) : 0 //报告合格率   检出上传照片数（至少上传一张则+1）/ 检出项目数

              item.systemUseRate = managerNum >0 ? ((item.managerActionPerson / managerNum)*100).toFixed(1) : 0 //系统使用率   管理人员登录人数/该店所有管理人员人数

              // item.saleRegistrationRate = item.itemFaultNum>0 ? ((item.itemFaultDealNum / item.itemFaultNum)*100).toFixed(1) : 0 //销售登记率   异常项目登记数/检测异常项目数 (检出项目数)
              item.saleRegistrationRate = item.itemFaultNum>0 ? ((item.abnormalFeedbackItemNum / item.criticalItemNum)*100).toFixed(1) : 0 //销售登记率   紧急项目登记数/紧急项目数
              item.customClickRate = item.testNum>0 ? ((item.carOwnerRequestPerson / item.testNum)*100).toFixed(1) : 0 //客户点击率   疑似客户数/检测台次

              item.shopSalesNumRate = item.itemFaultNum>0 ? ((item.shopSalesNum / item.itemFaultNum)*100).toFixed(1) : 0 // 增项成交率（增项成交项目数/检出项目数）

              dossierPositionImgNumSum += item.dossierPositionImgNum
              itemFaultDealNumSum += item.itemFaultDealNum
              carOwnerRequestPersonSum += item.carOwnerRequestPerson
              managerActionPersonSum += item.managerActionPerson
              abnormalFeedbackItemNumSum += item.abnormalFeedbackItemNum
              criticalItemNumSum += item.criticalItemNum
              receptionSalesNumSum += item.receptionSalesNum
              shopSalesNumSum += item.shopSalesNum

              testNumSum += item.testNum
              faultNumSum += item.faultNum
              dealNumSum += item.dealNum
              itemCheckNumSum += item.itemCheckNum
              itemFaultNumSum += item.itemFaultNum
              itemDealNumSum += item.itemDealNum

              tireTestNumSum += item.tireTestNum
              batteryTestNumSum += item.batteryTestNum

            })
            this.dailyTestAndDealData = data
            this.dossierPositionImgNumSum = dossierPositionImgNumSum
            this.itemFaultDealNumSum = itemFaultDealNumSum
            this.carOwnerRequestPersonSum = carOwnerRequestPersonSum
            this.abnormalFeedbackItemNumSum = abnormalFeedbackItemNumSum
            this.criticalItemNumSum = criticalItemNumSum

            this.testNumSum = testNumSum
            this.faultNumSum = faultNumSum
            this.dealNumSum = dealNumSum
            this.itemCheckNumSum = itemCheckNumSum
            this.itemFaultNumSum = itemFaultNumSum
            this.itemDealNumSum = itemDealNumSum
            this.tireTestNumSum = tireTestNumSum
            this.batteryTestNumSum = batteryTestNumSum
            this.receptionSalesNumSum = receptionSalesNumSum
            this.shopSalesNumSum = shopSalesNumSum

            let systemUseRateAvg = data.length * managerNum > 0 ? (managerActionPersonSum/((data.length - 1) * managerNum)*100).toFixed(1) : 0 //系统使用率   所有日期的管理员登录人数总和/（查询结果条数*该店所有管理人员人数）

            let itemDealRateAvg = itemFaultNumSum*1 + receptionSalesNumSum*1 > 0 ? (itemDealNumSum / (itemFaultNumSum*1 + receptionSalesNumSum*1) * 100).toFixed(1) : 0 //项目成交率   项目成交率=全部行的成交项目数/ （全部行的检出项目数+全部行前置成交项目数）* 100%

            this.systemUseRateAvg = systemUseRateAvg
            this.itemDealRateAvg = itemDealRateAvg
            this.totalPercentage = res.data.totalPercentage

            this.setWindowHeight();
          } else {
            net.message(this, res.retmsg, "warning");
          }
        })
      },
      // 导出数据
      exportTable(elTableId) {
        var wb = XLSX.utils.table_to_book(document.querySelector(elTableId));
        var wbout = XLSX.write(wb, {
          bookType: "xlsx",
          bookSST: true,
          type: "array"
        });
        try {
          FileSaver.saveAs(
            new Blob([wbout], { type: "application/octet-stream" }),
            "检测汇总月度统计.xlsx"
          );
        } catch (e) {
          if (typeof console !== "undefined") console.log(e, wbout);
        }
        return wbout;
      },
      // 设置滚动高度
      setWindowHeight() {
        const windiwHight = document.documentElement.clientHeight || document.body.clientHeight; // 可视屏幕高度
        console.log("windiwHight",windiwHight)
        this.winHeight = windiwHight  - 158;
      },

      setCustomizeRow(){
        this.customizeRow = true
      },


      // 数据处理
      tableDataHandle(arr, key, level = 0, indexLine = []) {
        if(arr){
          level = level + 1
          arr.map((item, idx) => {
            item.level = level
            item.indexLine = Object.assign([], indexLine)
            item.indexLine.push(idx)
            item.parentLength = arr.length
            if (item[key]) {
              this.tableDataHandle(item[key], key, level, item.indexLine)
            }
          })
          return arr
        }

      },

      getRowKey(v){
        return v.id
      },
      //全部
      handleCheckAllChange(val){
        this.checkedColumns = val ? columnOptions : [];
        this.isIndeterminate = false;
      },
      //修改选中情况
      handleCheckedList(val){
        this.checkedColumns=val;
        let checkedCount = val.length;
        this.checkAll = checkedCount === this.columns.length;
        this.isIndeterminate = checkedCount > 0 && checkedCount < this.columns.length;
      },
      // 恢复默认
      recoverChecked(){
        this.checkedColumns=['检出台数', '台数检出率','成交台数','检出台数成交率','检测项目数','单台项目检测均值',
          '检出项目数','项目检出率','单台项目检出均值','成交项目数', '检出项目成交率','前置成交项目数', '单车平均成交项目数', '报告合格率', '系统使用率',
          '销售登记率','客户点击率']
        this.fieldList=columnOptions;
      },
      // 确认
      submit(){
        this.customizeRow=false;
        //更新表格展示列
        this.fields.forEach((item)=>{
          item.visible=false;
        })
        this.checkedColumns.forEach((item)=>{
          for(let i=0;i<this.fields.length;i++){
            if(this.fields[i].label==item){
              this.fields[i].visible=true;
            }
          }
        })
        //更新表格列顺序
        //更改后列顺序this.fieldList
        this.fieldsTemp=[];//清空存放按指定顺序排列的fields数组
        let n=0;
        this.fieldList.forEach((item)=>{
          for(let i=0;i<this.fields.length;i++){
            if(this.fields[i].label==item){
              this.fieldsTemp[n++]=this.fields[i];
            }
          }
        })
        this.fields=this.fieldsTemp;
        this.$nextTick(() => {
          this.$refs['table'].doLayout();
        })
        this.setWindowHeight()
      },


      // 排序 升序
      compareAsc: function (property) {
        return function (a, b) {
          const value1 = a[property]*1;
          const value2 = b[property]*1;
          return value1 - value2;
        };
      },
      // 排序 降序
      compareDes: function(property) {
        return function (a, b) {
          const value1 = a[property]*1;
          const value2 = b[property]*1;
          return value2 - value1;
        }
      },
      handleKeyup(event){
        let self = this;
        const e = event || window.event || arguments.callee.caller.arguments[0]
        if(!e) return
        if (e.keyCode == 27) {
          let routeNmae = self.$route.name
          if(routeNmae != 'inCommonUse'){
            e.stopImmediatePropagation();
            self.$router.replace({ name: 'inCommonUse' })
          }
        }
      },

    },
    computed:{
      newFiveQuestions() {
        const startIndex = Math.max(this.questions.length - 5, 0);
        return this.questions.slice(startIndex);
      },
      activeFields: function(){
        return this.fields.filter((item)=>{
          return item.visible;
        })
      }
    },
    mounted() {
      window.addEventListener('keyup',this.handleKeyup)
      this.tableDataHandle(this.tableData, 'children')
    },
    beforeDestroy() {
      window.removeEventListener('keyup',this.handleKeyup)
    }
  };
</script>

<style lang="less" scoped>
    #userList {
        display: flex;
        flex-direction: column;
        margin: 24px 0 0 24px;
        background: #fff;
        padding-left: 12px;
        .search {
            background: #fff;
            padding-top: 12px;
            margin-bottom: 12px;
            display: flex;
            .block_box{
                width: 100%;
                .p_select {
                    display: flex;
                    /*padding: 0 24px 0px 0;*/
                    font-size: 12px;
                    float: left;
                    margin-right: 12px;
                    .search_label{
                        font-family: 'PingFang SC';
                        font-style: normal;
                        margin-right: 12px;
                        font-weight: 500;
                        font-size: 14px;
                        line-height: 40px;
                        color: #787E86;
                        white-space:nowrap
                    }

                    .el-input , .el-select{
                        width: 160px;
                    }
                }
                .search_btn {
                    /*width: 76px;*/
                    /*height: 36px;*/
                    background: #2B54FC;
                    box-shadow: 0px 4px 12px rgba(71, 134, 192, 0.24);
                    border-radius: 4px;
                    color: #FFFFFF;
                    font-size: 14px;
                }
                .add_btn {
                    /*width: 76px;*/
                    height: 36px;
                    background: rgba(148, 170, 204, 0.08);
                    border: 1px solid #2B54FC;
                    border-radius: 4px;
                    font-size: 14px;
                    color: #2B54FC;
                }
                .customize_btn {
                    color: #2B54FC;
                    height: 36px;
                    line-height: 36px;
                    margin-right: 12px;
                }
            }
        }
        .table {
            padding-right: 24px;
        }
        .pagination {
            position: relative;
            margin-top: 20px;

            .el-pagination {
                position: absolute;
                left: 0px;
            }

            .number .active {
                background: #009688 !important;
            }
        }

        .checkbox-laber .el-checkbox-group{
            display: flex;
            flex-flow: column;
            text-align: left;
            .el-checkbox {
                line-height: 30px;
            }
        }

        .field_item {
            margin: 6px;
            text-align: center;
            padding: 8px 0;
            cursor: pointer;
            border-radius: 10px;
            color: #409EFF;
            border: 1px solid #409EFF;
        }
        .field_item:hover {
            background-color: #409EFF;
            color: #fff;
            /*border: 1px solid #409EFF;*/
        }
    }
</style>
<style lang="less">
    .el-table .cell {
        white-space: pre-line;
    }
</style>


<style lang="less" scoped>
    .slider_button{
        position: absolute;
        top: 40%; /* 垂直方向上居中 */
        right: -7px; /* 距离右侧10px */
        writing-mode: vertical-lr; /* 字体竖直摆放 */
        display: inline-block;
        z-index: 1000; /* 确保按钮在最上层 */
        padding: 19px 31px; /* 按钮的内边距 */
        //background-color: #007bff; /* 按钮的背景颜色 */
        background-image:url('../../assets/img/ai/1.svg');
        background-size: contain; /* 根据 SVG 的尺寸调整背景大小 */
        background-position: center; /* 背景居中 */
        background-repeat: no-repeat; /* 背景不重复 */
        color: white; /* 按钮的文字颜色 */
        border: none; /* 无边框 */
        border-radius: 4px; /* 按钮的圆角 */
        cursor: pointer; /* 鼠标悬停时显示指针 */
        font-size: 16px;
    }
    .detail_item {
        text-align: left;
        background: #eee;
        padding: 10px;
        margin-bottom: 20px;
        font-size: 16px;
        line-height: 26px;
    }
    .custom-button {
        margin: 5px; /* 为按钮添加外边距 */
        padding: 10px 20px; /* 为按钮添加内边距 */
        border: none; /* 移除边框 */
        border-radius: 4px; /* 圆角边框 */
        cursor: pointer; /* 鼠标悬停时显示指针 */
        background-color: #409eff; /* 按钮背景颜色 */
        color: white; /* 文字颜色 */
    }
    .el-drawer__header {
        text-align: left;
        display: none;
    }
    .ai_box{
        display: flex;
        flex-wrap: wrap; /* 允许内容换行 */
        gap: 15px; /* 图片之间的间距 */
        margin-left: 10px;
        align-items: center;
        background-color: white;
    }

    .left-div {
        flex: 0 0 15%;
        margin-right: 10px; /* 可选：右侧外边距 */
    }

    .right-div {
        flex: 1;
        display: flex; /* 启用flexbox布局 */
        flex-direction: column; /* 设置子元素垂直排列 */
        align-items: flex-start; /* 水平左对齐子元素 */
    }
    .history_title {
        font-size: 22px;
        line-height: 36px;
    }
    .history_box {
        background-color: #eeeeee;
        width: 100%;
        height: calc(100% - 90px);
        overflow: hidden;
    }
    .detail_title_box {
        /*margin-top: 10px;*/
        height: 70px;
        background-color: #fff;
        display: flex;
        align-items: center;
        padding-left: 20px;
    }
    .title_img img{
        width: 50px;
        height: 50px;
    }
    .title_label {
        margin-left: 20px;
        font-size: 22px;
    }
    .history_list {
        height: 100%;
        padding-left: 10px;
        background-color: #fff;
        display: flex;
        flex-flow: column;
    }
    .history_item {
        display: flex;
        align-items: center;
        background-color: #bdbdbd;
        margin: 10px;
        padding: 10px;
        border-radius: 10px;
        cursor: pointer;
    }
    .history_item .item_img {
        margin-right: 10px;
    }
    .history_item .item_label {
        line-height: 20px;
    }

    .right-div-image {
        max-width: 100%; /* 确保图片不会超出.right-div的宽度 */
        height: auto; /* 保持图片的宽高比 */
        margin-bottom: 10px; /* 可选：为图片间添加间距 */
    }

    .ai_box #ai_title{
        position: relative;
        top: 5px;
    }

    .input-container {
        display: flex;
        align-items: center;
        border: 1px solid #ccc;
        padding: 5px;
        border-radius: 5px;
        background-color: #f9f9f9;
    }

    .input-text {
        flex: 1;
        border: none;
        outline: none;
        padding: 5px;
        margin-right: 10px;
        font-size: 16px;
    }

    .icons {
        display: flex;
        align-items: center;
    }

    .icon {
        width: 24px;
        height: 24px;
        margin: 0 5px;
        cursor: pointer;
    }

    .send-button {
        background-color: #007bff;
        color: white;
        border: none;
        padding: 7px 12px;
        cursor: pointer;
        border-radius: 5px;
    }

    .send-button:hover {
        background-color: #0056b3;
    }

    /*.input-wrapper {
      position: relative;
      //display: flex;
      align-items: flex-start; !* 确保输入框内的文字顶头输入 *!
      background-color: #fff; !* 输入框背景颜色 *!
      //border: 1px solid #ccc; !* 输入框边框 *!
      border-radius: 4px; !* 输入框圆角 *!
      height: 150px; !* 设置输入框容器的高度为150px *!
      padding: 10px; !* 为输入框容器添加一些内边距 *!
      //overflow: hidden; !* 防止内容溢出 *!
      width:100%;
      transition: height 0.3s ease; // 添加过渡效果
    }

    .input-wrapper.send-active {
      height: 0; // 点击发送后的高度变为0
    }

    .input-field {
      border: none; !* 去除输入框边框 *!
      width: 100%; !* 使输入框占据整个容器的宽度 *!
      height: 100%; !* 设置输入框的高度为容器的高度 *!
      font-size: 16px; !* 调整字体大小 *!
      resize: none; !* 防止用户调整输入框大小 *!
      overflow: auto; !* 当内容超出时显示滚动条 *!
      padding: 10px; !* 保持原有的内边距 *!
      box-sizing: border-box; !* 确保内边距和边框不增加输入框的总宽度和高度 *!
      line-height: 1.5; !* 设置行高 *!
      word-wrap: break-word; !* 允许长单词或URL换行 *!
      white-space: pre-wrap; !* 保持空格并允许换行 *!
    }

    .input-field::placeholder {
      font-family: 'Courier New', Courier, monospace; !* 设置等宽字体 *!
    }

    .buttons {
      position: relative;
      bottom: 0px; !* 从底部10px的位置开始 *!
      left: 75%; !* 从右边10px的位置开始 *!
      display: flex;
      align-items: center;
    }

    .send-button,
    .other-button {
      padding: 8px 12px;
      margin-left: 5px;
      background-size: cover; !* 覆盖整个按钮 *!
      border: none;
      border-radius: 4px;
      cursor: pointer;
      background: white;
      //width: 76%; !* 根据图片大小设置宽度 *!
      //height: 10px; !* 根据图片大小设置高度 *!
    }



    .button-with-image1 {

      //background-size: contain; !* 确保背景图像完全包含在元素内 *!
      background-size: cover; !* 覆盖整个按钮 *!
      background-position: center;
      border: none; !* 无边框 *!
      cursor: pointer; !* 鼠标悬停时显示指针 *!
      color: transparent; !* 隐藏文本 *!
      outline: none; !* 点击时不显示轮廓 *!
      background-image: url('./button1.svg'); !* 设置背景图像 *!
      margin-left: -18%; !* 增加左边距 *!
      margin-bottom: 7px;
      width: 75%; !* 根据图片大小设置宽度 *!
      height: 53px; !* 根据图片大小设置高度 *!

    }

    .button-with-image2{
      //background-size: contain; !* 确保背景图像完全包含在元素内 *!
      background-size: cover; !* 覆盖整个按钮 *!
      background-position: center;
      border: none; !* 无边框 *!
      cursor: pointer; !* 鼠标悬停时显示指针 *!
      color: transparent; !* 隐藏文本 *!
      outline: none; !* 点击时不显示轮廓 *!
      background-image: url('./functionbutton.svg'); !* 设置背景图像 *!
      margin-left: 15%; !* 增加左边距 *!
      margin-bottom: -10px;
      width: 31%; !* 根据图片大小设置宽度 *!
      height: 55px; !* 根据图片大小设置高度 *!
    }*/

    .chat-window {
        display: flex;
        flex-direction: column;
        height: 90vh;
        width: 98%;
        //border: 1px solid #ccc;
        padding: 10px;
        overflow: hidden;
        background-color: #f5f7fa;
    }

    .image-container {
        display: flex;
        justify-content: center;
        //align-items: center;
        height: 100vh; /* 使容器占满整个视口高度 */
    }

    .messages {
        flex-grow: 1;
        overflow-y: auto;
        padding: 10px;
        transition: height 0.3s ease; // 添加过渡效果
    }

    .message {
        margin-bottom: 10px;
    }

    .message-content {
        text-align: left; /* 确保文本靠左显示 */
        background-color: #f0f0f0;
        padding: 8px;
        border-radius: 4px;
        font-size: 16px;
        line-height: 1.5;
        white-space: pre-wrap;
    }

    .my-message .message-content {
        background-color: #5954f0;
        color: #fff;
    }
    .op_box {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        margin-top: 6px;
    }
    .against {
        transform: scaleY(-1);
    }
    .op_item {
        cursor: pointer;
    }
    .op_item img{
        width: 20px;
        margin-right: 10px;
        /*cursor: pointer;*/
    }

    .message-meta {
        font-size: 12px;
        color: #888;
    }

    .question-content-wrapper {
        /*margin-top: 10px; !* 调整整体向下移动的距离 *!*/
        //border: 1px solid #ccc;
        padding: 10px;
        //background-color: #e6f7ff;
        border-radius: 5px;
    }

    /* 渐变背景样式 */
    .gradient-background {
        background:linear-gradient(to bottom, #67c8ff, #cfffff);
        width: 100%;
        padding: 10px; /* 根据需要调整内边距 */
        /* 其他样式 */
    }
    .xiaoyi{
        width: 100%;
        height: 60px;
        border-collapse: collapse;
        background: linear-gradient(to left,  #67c8ff,#0073eb, #40a9ff);
        display: flex; /* 启用Flexbox布局 */
        align-items: center; /* 垂直居中 */
        justify-content: flex-end; /* 水平靠右 */
        border: 1px solid #000; /* 边框用于可视化div的边界 */
        padding-right: 20px; /* 调整靠右的距离 */

        .img{
            max-height: 100%; /* 确保图片不会超出div的高度 */
            width: auto; /* 保持图片的宽高比 */
        }
        .tubiaoimg {
            margin-right: 110px; /* 第二张图片与第一张图片之间的距离 */
            margin-bottom: 35px;
        }
    }

    .question-suggestions {
        /*max-height: 232px; !* 根据需要调整高度以显示五个列表项 *!*/
        //overflow-y: auto; /* 启用垂直滚动条 */
        //border: 1px solid #ccc; /* 可选：添加边框以便更清楚地看到滚动区域 */
        padding: 5px; /* 可选：添加内边距 */
        border-radius: 5px; /* 可选：添加圆角 */
    }

    .question-suggestions h3 {
        text-align: left; /* 确保文本靠左显示 */
        margin-bottom: 14px;
        margin-top: 5px;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
    .question-suggestions .change_question_statue {
        cursor: pointer;
        display: flex;
        align-items: center;
        color: #fff;
    }
    .question-suggestions .change_question_statue img {
        margin-left: 6px;
        width: 20px;
    }

    ul {
        list-style-type: none;
        padding: 0;
        margin: 0; /* 移除默认的外边距 */
    }

    li {

        display: flex;
        align-items: center;
        padding: 4px;
        cursor: pointer;
        background-color: #ffffff;
        margin-bottom: 10px;
        border-radius: 3px;
        transition: background-color 0.3s;
        border-bottom: 1px solid #eee; /* 添加列表项之间的分隔线 */
    }
    .five_questions_item {
        width: 100%;
        display: flex;
        align-items: center;
    }
    .five_questions_item .msg_img img{
        width: 20px;
        height: 20px;
    }

    .list-item-content {
        width: calc(100% - 24px);
        display: flex;
        justify-content: space-between; /* 文本靠左，图片靠右 */
        width: 100%; /* 确保flex容器占满整个<li>宽度 */
        padding: 4px;
        font-size: 14px;
        text-align: left;
    }
    .list-item-content span {
        line-height: 20px;
    }

    .list-item-image {
        max-height: 100%; /* 确保图片不会超出<li>的高度 */
        width: auto; /* 保持图片的宽高比 */
    }

    li:last-child {
        border-bottom: none;
    }

    li:hover {
        background-color: #f0f0f0;
    }
</style>

